import React, { memo } from "react";
import Input from "./Input/Input";
import { Password } from "./Password/Password";
import Select from "./Select/Select";
import Checkbox from "./Checkbox/Checkbox";
import TextArea from "./TextArea/TextArea";
import DragDropFileInput from "./FileDragDrop/DragDropFileinput";
import {
  FormControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";
import withLabelAndError from "./withLabelAndError";
import ViewPasswordFormate from "./Password/component/ViewPasswordFormat";
import Date from "./Date/Date";
import Slider from "./Slider/Slider";
import DateRangeInput from "./DateRange/DateRangeInput";
import Toggle from "./ToggleInput/ToggleInput";
import FileInputWithLabelAndError from "./FileInput/FileInput";
import RichTextWithLabelAndError from "./RichTextEditor/RichTextEditor";
import TimeInputWithLabelAndError from "./TimeInput/TimeInput";
import ImageInputWithLabelAndError from "./ImageInput/ImageInput";
import SelectablePillsWithLabelAndError from "./SelectablePills/SelectablePills";
import CheckboxGroupWithLabelAndError from "./CheckboxGroup/CheckboxGroup";

const PasswordWithInstructions = withLabelAndError(
  Password as WithLabelAndErrorComponent,
  ViewPasswordFormate,
);

const PasswordWithLabelAndError = withLabelAndError(
  Password as WithLabelAndErrorComponent,
);

const FormControl: React.FC<FormControlProps> = ({
  controlType,
  popupInstructions,
  ...rest
}) => {
  const restProps = rest as FormControlProps;

  const withControlType = { ...rest, controlType } as FormControlProps;
  switch (controlType) {
    case "input":
      return <Input {...restProps} />;
    case "password":
      return popupInstructions ? (
        <PasswordWithInstructions {...restProps} />
      ) : (
        <PasswordWithLabelAndError {...restProps} />
      );
    case "textarea":
      return <TextArea {...withControlType} />;
    case "select":
      return <Select {...restProps} />;
    case "dragdropfile":
      return <DragDropFileInput {...restProps} />;
    case "checkbox":
      return <Checkbox {...withControlType} />;
    case "date":
      return <Date {...restProps} />;
    case "daterange":
      return <DateRangeInput {...restProps} />;
    case "slider":
      return <Slider {...restProps} />;
    case "toggle":
      return <Toggle {...restProps} />;
    case "richtexteditor":
      return <RichTextWithLabelAndError {...restProps} />;
    case "fileInput":
      return <FileInputWithLabelAndError {...restProps} />;
    case "time":
      return <TimeInputWithLabelAndError {...restProps} />;
    case "imageInput":
      return <ImageInputWithLabelAndError {...restProps} />;
    case "selectablePills":
      return <SelectablePillsWithLabelAndError {...restProps} />;
    case "checkboxGroup":
      return <CheckboxGroupWithLabelAndError {...restProps} />;
    default:
      return null;
  }
};

export default memo(FormControl);
